import { createContext } from 'react';

const SubmitContext = createContext({});

export default SubmitContext;
